<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      title="命名模板"
      id-key="UserId"
    >

        <div>
            <el-input v-model="moduleName" placeholder="请输入模板名" />
        </div>

      <template slot="footer">
        <el-button type="primary"  @click="enter"
          >确定</el-button
        >
    
        <!-- <el-button type="primary" @click="lodopPrint">打印</el-button> -->
      </template>
    </common-dialog>

    
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

// import {getLodop} from '@/utils/LodopFuncs'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },


  data() {
    return {
        moduleName: "",
    }
  },
  methods: {
    enter(){
        if(this.moduleName === ""){
            this.$message({
                type: 'warning',
                message: "模板名不能为空"
            })
            return
        }

        this.$emit('saved', this.moduleName);
        this.close();
    }
  }

};
</script>


